if (!customElements.get('deferred-iframe')) {
  class DeferredIframe extends HTMLElement {
    constructor() {
      super();

    }

    connectedCallback() {
      const videoTriggers = this.querySelectorAll('[data-video-text-container], .deferred-play-button');
      if (!videoTriggers.length) return;
    
      const loadContentBound = this.loadContent.bind(this);
    
      videoTriggers.forEach((element) => {
        element.addEventListener('click', loadContentBound);
      });

      // YouTube Thumbnail backup
      this.replacePlaceholderThumbnail();
    }

    replacePlaceholderThumbnail() {
      const thumbnail = this.querySelector('img.youtube-thumbnail');
      if (!thumbnail) return;
    
      thumbnail.addEventListener('load', function () {
    
        if (this.naturalWidth <= 120) {
          console.log('Placeholder detected. Replacing with new image.');
    
          // Create a new image element
          const newThumbnail = thumbnail.cloneNode();
    
          // Update the src for the new image
          const newSrc = this.src.replace('maxresdefault.jpg', 'sddefault.jpg');
          newThumbnail.src = newSrc;
    
          // Remove Maxres from the srcset
          if (newThumbnail.srcset) {
            const newSrcset = newThumbnail.srcset.split(',').slice(1).join(',').trim();
            newThumbnail.srcset = newSrcset;
          }
    
          // Remove lazyloading classes
          newThumbnail.className = 'youtube-thumbnail';
    
          // Replace the old thumbnail with the new one
          thumbnail.replaceWith(newThumbnail);
        }
      });
    }

    loadContent() {

      if (!this.getAttribute('loaded')) {
      
      const videoContainer = this.querySelector('[data-video-element]');

      videoContainer.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);

      }
    }
  }

  customElements.define('deferred-iframe', DeferredIframe)
}